import { useDriver } from "./hook";
import { driverMutations } from "./mutation";
import { driverQueries } from "./queries";

export const driverService = {
  query: driverQueries,
  mutation: driverMutations,
  useDriver
};
